<template>
<div class="columns">
    <data-view-parents v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="data in dataList" :data="data" v-bind:key="data._id" class="column is-6 box" v-bind:class="isActive(data.status)"></data-view-parents>
</div>
</template>

<style scoped>
.box{
    border: 1px solid #ccc;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>
<script>
import DataViewParents from './DataViewParents';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
        };
    },
    props: ['dataList'],
    components: {
        DataViewParents,
    },
    methods: {
        isActive(myStatus){
            if (myStatus == 1){
                return "active"
            }else{
                return ""
            }
        },        
        deleteData(data) {
            let self = this;
            this.$swal({
                title: "Are you sure?",
                text: "This parent's notification (" + data.name + ") will be permanently removed.",
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: true
            }).then((result) => {
                if (result.value){

                    const dataIndex = this.dataList.indexOf(data);
                    this.dataList.splice(dataIndex, 1);

                    axios.defaults.responseType = 'json'
                    axios.post(process.env.NEW_ENDPOINT + '/behaviors/remove/', {
                        token: localStorage.getItem('jwtTokenV2'),
                        email: localStorage.getItem('email'),
                        _id: data._id,
                    }).then(response => {
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                        }
                    })
                    .catch(e => {
                        console.log(e.response)
                        if (e.response.status === 401) {
                            console.log("salah login")
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 10000
                            })
                        } else {
                            Toast.open({
                                message: e,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 10000
                            })
                        }
                    })
                }
            })
        },
        updateData(data) {
            let self = this;

            var name = data.name;
            var restrictAwardBy = data.restrictAwardBy;
            var restrictAwardTo = data.restrictAwardTo;
            var colour = data.colour;
            var selectedColour = data.colour;
            var initialSelectedColour = data.initialSelectedColour;
            var info = data.info;
            var isRemarksMandatory = data.isRemarksMandatory;
            var status = data.status;

            if (name.length < 1){
                Toast.open({
                    message: "Please enter notification's name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }

            if (restrictAwardBy == 3){
                if ((!restrictAwardTo) || (restrictAwardTo.length < 1)){
                    Toast.open({
                        message: "Please select the teachers that can send this notification",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }

            if (!colour.hex){
                selectedColour = initialSelectedColour
            }else{
                selectedColour = colour.hex
            }
            
            if (!status){
                status = 1
            }else{
                status = parseInt(status)
            }

            self.isLoading = true;

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/update/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                _id: data._id,
                name: name,
                points: 0,
                dataType: 3,
                restrictAwardBy: restrictAwardBy,
                restrictAwardTo: restrictAwardTo,
                maxDailyCountOverall: -1,
                status: status,
                colour: selectedColour,
                info: info,
                isMandatory: 0,
                isRemarksMandatory: isRemarksMandatory,
                sendNotification: 0,
                enableFaceCapture: 0,
                enableLocation: 0 
            })
            .then(response => {
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                }
            })
            .catch(e => {
                console.log("165 e")
                console.log(e.response)
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })           
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Manage/Notifications/DataListParents.vue